<template>
    <div class="fixedChangeBox">
         <div class="changeBox">
              <div class="mianBox clearfix" :class="{small:size=='small'}">
                <div :class="{active: checked == true }" @click='change()'  class="leftBox" >
                    <p>{{title1}}</p>
                </div>
                <div :class="{active: checked == false }" class="rightBox" @click="change()">
                    <p>{{title2}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    title1: {
      default: ""
    },
    title2: {
      default: ""
    },
    size: {
      default: ""
    },
    ck: {
      default: true
    }
  },
  data() {
    return {
      checked: true
    };
  },
  mounted() {
    this.checked = this.ck;
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit("change", this.checked);
    },
    setSwitch(v){
        this.checked = v;
    }
  }
};
</script>
<style lang='less'>
.fixedChangeBox {
  .changeBox {
    .mianBox {
      margin: 0 auto;
      width: 150px;
      height: 35px;
      position: relative;
      .leftBox,
      .rightBox {
        background-color: #d1d1d1;
        height: 35px;
        width: 100px;
        left: 0;
        position: absolute;
        text-align: center;
        line-height: 35px;
        float: left;
        color: #fff;
        border-radius: 0.896rem;
      }
      .rightBox {
        left: 75px;
      }
      .active {
        background-color: #f69c2d;

        font-weight: bold;
        z-index: 1;
      }
    }
    .small {
      width: 100px;
      .leftBox,
      .rightBox {
        width: 75px;
      }
      .rightBox {
        left: 50px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// switch.vue?70b41d3c